import React, { useCallback, useEffect } from 'react';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { View } from 'react-native';

import Board from './components/Board';
import PlanboardHeader from './components/Header';
import ColorWrapper, { WithColor } from '@styles/colors';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { getMachinesGroup } from '@reducers/machines';
import { role } from '@components/frame';
import { isRestrictedForOperator, RESTRICTION_CATEGORIES } from '@config/operatorRestrictions';
import { useTrackPlanboardOpened } from './hooks/useTrackPlanboardOpened';

interface PlanboardProps extends WithColor {}

const Planboard: React.FC<PlanboardProps> = ({ C }) => {
  const dispatch = useAppDispatch();
  const navigation = useNavigation<any>();

  useTrackPlanboardOpened();

  // Route guard: redirect operators to machines
  useEffect(() => {
    if (isRestrictedForOperator(role || '', RESTRICTION_CATEGORIES.WEB_TABS, 'Planboard')) {
      navigation.replace('Authorized');
    }
  }, [navigation]);

  useFocusEffect(
    useCallback(() => {
      dispatch(getMachinesGroup());
    }, [])
  );

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: C('Background/Light/Detail'),
      }}
    >
      <PlanboardHeader />
      <Board />
    </View>
  );
};

export default ColorWrapper(Planboard);
